import React, { useState } from 'react';
import './SideNavigation.css';
import GlobalSearch from './GlobalSearch';
import UserProfile from './UserProfile';

interface SideNavigationProps {
  activeView: string;
  onViewChange: (view: string) => void;
  selectedCommune?: string;
  selectedProject?: string;
  selectedRoad?: string;
}

const SideNavigation: React.FC<SideNavigationProps> = ({
  activeView,
  onViewChange,
  selectedCommune,
  selectedProject,
  selectedRoad
}) => {
  const [showProfile, setShowProfile] = useState(false);
  const [userName, setUserName] = useState('');

  React.useEffect(() => {
    const saved = localStorage.getItem('userProfile');
    if (saved) {
      const profile = JSON.parse(saved);
      setUserName(profile.name || 'Utilisateur');
    }
  }, [showProfile]);
  const handleSearchNavigate = (type: string, id: number, roadId?: number) => {
    if (type === 'commune') {
      onViewChange('communes');
    } else if (type === 'road' && roadId) {
      onViewChange('sections');
    } else if (type === 'section' && roadId) {
      onViewChange('sections');
    }
  };

  return (
    <>
      <button className="mobile-menu-toggle" onClick={() => document.querySelector('.side-navigation')?.classList.toggle('open')}>
        ☰
      </button>
      <div className="mobile-overlay" onClick={() => document.querySelector('.side-navigation')?.classList.remove('open')}></div>
      <nav className="side-navigation">
        <div className="nav-header">
          <h2>🛣️ OFRU</h2>
          <button className="mobile-close" onClick={() => document.querySelector('.side-navigation')?.classList.remove('open')}>✕</button>
        </div>
      
      <div className="nav-search">
        <GlobalSearch onNavigate={handleSearchNavigate} />
      </div>
      
      <div className="nav-menu">
        <div className="nav-section">
          <button 
            className={`nav-item ${activeView === 'dashboard' ? 'active' : ''}`}
            onClick={() => onViewChange('dashboard')}
          >
            <span className="nav-icon">📊</span>
            <span className="nav-label">Tableau de Bord</span>
          </button>
          
          <button 
            className={`nav-item ${activeView === 'projects' ? 'active' : ''}`}
            onClick={() => onViewChange('projects')}
          >
            <span className="nav-icon">📁</span>
            <span className="nav-label">Projets</span>
          </button>
          
          <button 
            className={`nav-item ${activeView === 'communes' ? 'active' : ''}`}
            onClick={() => onViewChange('communes')}
          >
            <span className="nav-icon">🏘️</span>
            <span className="nav-label">Communes</span>
          </button>
        </div>
        
        {selectedProject && (
          <div className="nav-section">
            <div className="nav-subtitle">📁 {selectedProject}</div>
          </div>
        )}
        
        {selectedCommune && (
          <div className="nav-section">
            <div className="nav-subtitle">📍 {selectedCommune}</div>
          </div>
        )}
        
        {selectedRoad && (
          <div className="nav-section">
            <div className="nav-subtitle">🛣️ {selectedRoad}</div>
            <button 
              className={`nav-item sub-item ${activeView === 'sections' ? 'active' : ''}`}
              onClick={() => onViewChange('sections')}
            >
              <span className="nav-icon">📝</span>
              <span className="nav-label">Tronçons</span>
            </button>
            <button 
              className={`nav-item sub-item ${activeView === 'road-dashboard' ? 'active' : ''}`}
              onClick={() => onViewChange('road-dashboard')}
            >
              <span className="nav-icon">📈</span>
              <span className="nav-label">Analyse</span>
            </button>
          </div>
        )}
      </div>
      
      <div className="nav-footer">
        <button className="profile-btn" onClick={() => setShowProfile(true)}>
          <span className="profile-icon">👤</span>
          <span className="profile-name">{userName || 'Profil'}</span>
        </button>
      </div>
      </nav>
      
      {showProfile && <UserProfile onClose={() => setShowProfile(false)} />}
    </>
  );
};

export default SideNavigation;